var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNivelesTakt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.52632H12V9.57895H14V10.9474H12V13H10.6667V10.9474H8.66667V9.57895H10.6667V7.52632ZM1.33333 0H10.6667C11.0203 0 11.3594 0.144172 11.6095 0.400801C11.8595 0.65743 12 1.00549 12 1.36842V6.21263C10.997 6.03968 9.96735 6.26472 9.12 6.84211H6.66667V9.57895H7.38667C7.31333 10.0442 7.31333 10.5026 7.38667 10.9474H1.33333C0.979711 10.9474 0.640573 10.8032 0.390524 10.5466C0.140476 10.2899 0 9.94188 0 9.57895V1.36842C0 1.00549 0.140476 0.65743 0.390524 0.400801C0.640573 0.144172 0.979711 0 1.33333 0ZM1.33333 2.73684V5.47368H5.33333V2.73684H1.33333ZM6.66667 2.73684V5.47368H10.6667V2.73684H6.66667ZM1.33333 6.84211V9.57895H5.33333V6.84211H1.33333Z",
    fill: "#2C3421"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivelesTakt);
export default __webpack_public_path__ + "static/media/niveles-takt.1b086793e71d290932357ab2860921b1.svg";
export { ForwardRef as ReactComponent };